import * as z from 'zod/mini'
import { imageFields } from '../../schemas/image'
import type { ImageInfo, PremiseImages } from '../../types/interfaces/image.interface'

/** An image URL (`.../gallery/:imageId`), looked up by `ImageGuard` within the premise and its activity. */
export const imageParams = z.object({ imageId: z.uuid() })
export type ImageParams = z.infer<typeof imageParams>

/** `PATCH .../gallery/:imageId` - the image's alternative text. */
export const editImageBody = z.object({ alt: imageFields.alt })
export type EditImageBody = z.infer<typeof editImageBody>

/** `PUT .../gallery/order` - every image of the gallery, in the new order. A missing or foreign id is a 400. */
export const reorderGalleryBody = z.object({ imageIds: z.array(z.uuid()) })
export type ReorderGalleryBody = z.infer<typeof reorderGalleryBody>

/** What every premise image route answers: the premise's logo and gallery as they are after the change. */
export type PremiseImagesResponse = PremiseImages

/** What every activity gallery route answers: the gallery as it is after the change. */
export interface ActivityGalleryResponse {
  gallery: ImageInfo[]
}
